var a="#012040";export{a as default};
